import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import { SidebarItem } from '@backstage/core-components';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useEffect, useState } from 'react';

const DARK_THEME_ID = 'backstage-theme-dark';
const LIGHT_THEME_ID = 'backstage-theme-light';

export const DarkLightThemeSwitchButton = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const [themeId, setThemeId] = useState(appThemeApi.getActiveThemeId());

  useEffect(() => {
    const sub = appThemeApi.activeThemeId$().subscribe(setThemeId);
    return () => sub.unsubscribe();
  }, [appThemeApi]);

  const isDark = themeId === DARK_THEME_ID;

  const handleToggle = () => {
    appThemeApi.setActiveThemeId(isDark ? LIGHT_THEME_ID : DARK_THEME_ID);
  };

  return (
    <SidebarItem
      icon={(isDark ? Brightness7Icon : Brightness4Icon) as never}
      text={isDark ? 'Light Mode' : 'Dark Mode'}
      onClick={handleToggle}
      data-testid="theme-switch-button"
    />
  );
};
